/*******************************************************************************
 * Copyright (c) 2023 GetChkd
 *
 * All rights reserved.
 *
 * Contributors:
 *  James Worthington - Initial implementation
 *  Amina Rais - Massive Improvements
 *  Version: 2.0.0
 *
 *******************************************************************************/

import { createSlice } from '@reduxjs/toolkit';  
import { getAllApplicationUsers, getAllOrgsAppsUsersByOrgID, getAppUserHistory } from './applicationUsersAction';

const initialState = {
    data: {},
    orgAppsUsersList: {},
    orgAppUserHistory: {}
}
const applicationUsersSlice = createSlice({
    name: 'application',
    initialState,
    extraReducers: {

        [getAllOrgsAppsUsersByOrgID.fulfilled]: (state, { payload }) => {
            state.orgAppsUsersList =  payload;
        },
        [getAllApplicationUsers.fulfilled]: (state, { payload }) => {
            state.orgAppsUsersList =  payload;
        },
        [getAppUserHistory.fulfilled]: (state, { payload }) => {
            state.orgAppUserHistory =  payload;
        },
        [getAppUserHistory.rejected]: (state, { payload }) => {
            state.orgAppUserHistory =  {};
        },
    }
});

export default applicationUsersSlice.reducer;